import * as THREE from "three";
import { sizes } from "./constants";

export const camera = new THREE.PerspectiveCamera(
  15,
  sizes.width / sizes.height,
  0.1,
  100
);
// camera.position.x = 0;
// camera.position.y = 7;
// camera.position.z = 0;

camera.position.x = -0.8;
camera.position.y = 4.5;
camera.position.z = 4.5;
